var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlatformFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_307_117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 16H13C14.6569 16 16 14.6574 16 13.0005V6L10 0H3.00007C1.34322 0 0 1.34315 0 3V13C0 14.6569 1.34315 16 3 16Z",
    fill: "url(#paint0_linear_307_117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 15.75H3C1.48122 15.75 0.25 14.5188 0.25 13V3C0.25 1.48123 1.48128 0.25 3.00007 0.25H9.89645L15.75 6.10355V13.0005C15.75 14.5192 14.5188 15.75 13 15.75Z",
    stroke: "black",
    strokeOpacity: 0.06,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_307_117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 4V0L16 6H12C10.8954 6 10 5.10457 10 4Z",
    fill: "url(#paint1_linear_307_117)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80429 8.1753C9.00856 8.07922 9.25186 8.17042 9.34266 8.3771C9.4302 8.57639 9.34296 8.80915 9.14598 8.90179L7.6168 9.62102C6.86817 9.97314 6.39029 10.726 6.39028 11.5533L6.39028 13.6097C6.39028 13.8253 6.21554 14 6 14C5.78445 14 5.60972 13.8253 5.60972 13.6097L5.60972 11.5533C5.60972 10.726 5.13184 9.97314 4.3832 9.62102L2.85402 8.90179C2.65704 8.80915 2.5698 8.57639 2.65734 8.3771C2.74814 8.17042 2.99144 8.07922 3.19571 8.1753L5.00144 9.0246C5.63392 9.32208 6.36609 9.32208 6.99857 9.0246L8.80429 8.1753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.62528 6.03956C5.87343 5.98681 6.1299 5.98681 6.37805 6.03956C6.65945 6.09937 6.91769 6.2486 7.29132 6.46451C7.30775 6.47401 7.3244 6.48363 7.34129 6.49338L8.36868 7.08654C8.38556 7.09629 8.40222 7.1059 8.41865 7.11538C8.79245 7.331 9.05081 7.48003 9.24331 7.69382C9.41307 7.88235 9.5413 8.10446 9.6197 8.34574C9.7086 8.61935 9.70848 8.91761 9.70832 9.34913C9.70831 9.36811 9.7083 9.38734 9.7083 9.40684V10.5932C9.7083 10.6127 9.70831 10.6319 9.70832 10.6509C9.70848 11.0824 9.7086 11.3807 9.6197 11.6543C9.5413 11.8955 9.41307 12.1176 9.24331 12.3062C9.05081 12.52 8.79245 12.669 8.41865 12.8846C8.40222 12.8941 8.38556 12.9037 8.36868 12.9135L7.34129 13.5066C7.3244 13.5164 7.30775 13.526 7.29132 13.5355C6.91769 13.7514 6.65945 13.9006 6.37805 13.9604C6.1299 14.0132 5.87343 14.0132 5.62528 13.9604C5.34388 13.9006 5.08564 13.7514 4.71201 13.5355C4.69558 13.526 4.67893 13.5164 4.66204 13.5066L3.63465 12.9135C3.61777 12.9037 3.60111 12.8941 3.58467 12.8846C3.21088 12.669 2.95251 12.52 2.76001 12.3062C2.59026 12.1176 2.46203 11.8955 2.38363 11.6543C2.29473 11.3807 2.29484 11.0824 2.29501 10.6509C2.29502 10.6319 2.29503 10.6127 2.29503 10.5932V9.40684C2.29503 9.38734 2.29502 9.36811 2.29501 9.34913C2.29484 8.91761 2.29473 8.61935 2.38363 8.34574C2.46203 8.10446 2.59026 7.88235 2.76001 7.69382C2.95251 7.48003 3.21088 7.331 3.58467 7.11538C3.60111 7.1059 3.61777 7.09629 3.63465 7.08654L4.66204 6.49338C4.67892 6.48363 4.69558 6.47401 4.712 6.46451C5.08563 6.24861 5.34388 6.09937 5.62528 6.03956ZM6.22749 6.74786C6.0786 6.71621 5.92472 6.71621 5.77583 6.74786C5.62087 6.7808 5.46733 6.86459 5.0241 7.12049L3.99671 7.71365C3.55348 7.96955 3.40414 8.06062 3.29814 8.17835C3.19629 8.29147 3.11935 8.42474 3.07231 8.5695C3.02336 8.72017 3.01915 8.89504 3.01915 9.40684V10.5932C3.01915 11.105 3.02336 11.2798 3.07231 11.4305C3.11935 11.5753 3.19629 11.7085 3.29814 11.8216C3.40414 11.9394 3.55348 12.0305 3.99671 12.2864L5.0241 12.8795C5.46733 13.1354 5.62087 13.2192 5.77583 13.2521C5.92472 13.2838 6.0786 13.2838 6.22749 13.2521C6.38245 13.2192 6.536 13.1354 6.97923 12.8795L8.00661 12.2864C8.44985 12.0305 8.59918 11.9394 8.70519 11.8216C8.80704 11.7085 8.88398 11.5753 8.93102 11.4305C8.97997 11.2798 8.98418 11.105 8.98418 10.5932V9.40684C8.98418 8.89504 8.97997 8.72017 8.93102 8.5695C8.88398 8.42474 8.80704 8.29147 8.70519 8.17835C8.59918 8.06062 8.44985 7.96955 8.00661 7.71365L6.97923 7.12049C6.536 6.86459 6.38245 6.7808 6.22749 6.74786Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_307_117",
    x: 8,
    y: -1,
    width: 10,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_307_117"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_307_117",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_307_117",
    x1: 1,
    y1: 1,
    x2: 14.5,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0806874,
    stopColor: "#EAF765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155366,
    stopColor: "#E8F666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22496,
    stopColor: "#E3F468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.290394,
    stopColor: "#DEF36A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352593,
    stopColor: "#D6F06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41248,
    stopColor: "#CEED6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.470981,
    stopColor: "#C4EA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529019,
    stopColor: "#B8E677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58752,
    stopColor: "#ACE27B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647407,
    stopColor: "#9EDE80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709606,
    stopColor: "#90D985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77504,
    stopColor: "#80D48B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844634,
    stopColor: "#6FCF91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919313,
    stopColor: "#5EC997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CC39D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_307_117",
    x1: 13,
    y1: 3,
    x2: 10,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.514828,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_307_117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformFile);
export default __webpack_public_path__ + "static/media/platform-file.933adacf0c19e0b46e08e5c938efaa90.svg";
export { ForwardRef as ReactComponent };